import { useState } from "react";
import { DocumentSignerKey } from "./key";
import { SimpleQueryOptions, useBaseQuery } from "../baseQuery";
import { snakeCasedObject } from "@maven-rest/common/HttpRequest";
import { GetDocumentSignBySignerTokenRequest, GetDocumentSignBySignerTokenResponse } from "@maven-rest/docs/DocumentSign.dto";
import { DocumentSignerUrl } from "@maven-rest/docs/DocumentSigner.url";

export function useDocumentSignBySignerTokenLazyQuery(
  options?: SimpleQueryOptions<GetDocumentSignBySignerTokenResponse, GetDocumentSignBySignerTokenRequest>
) {
  const [query, setQuery] = useState<GetDocumentSignBySignerTokenRequest | null>(null);

  const changeTriggerQuery = (newReq: GetDocumentSignBySignerTokenRequest) => {
    setQuery(newReq);
  };

  const baseQuery = useBaseQuery({
    queryKey: [DocumentSignerKey.DocumentSignBySignerToken, query?.token, query?.personalIdentificationEncrypted],
    fnOption: {
      url: DocumentSignerUrl.getDocumentSignBySignerToken(query?.token || ""),
      request: query ? snakeCasedObject(query, ",") : {},
    },
    enabled: !!query,
    ...options,
  });

  return {
    ...baseQuery,
    trigger: changeTriggerQuery,
  };
}
